// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"24":"component---src-pages-impressum-tsx","245":"component---src-pages-index-tsx","386":"component---src-pages-datenschutz-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"24":"37676abd4aa37bb00205","245":"15f1f9e3f431fe2770d1","386":"0a941ba950c3b6e4ccac","453":"da9b7b20913f6498b864"}[chunkId] + ".js";
};